import { memo } from "react";
import ImportComponent from "./ImportComponent";
import {
  ClientsJsonArrInput,
  Gender,
  InternalClientsInput,
  useClientSampleCsvLazyQuery,
  useMigrateClientsMutation,
} from "src/generated/graphql";
import { IJsonArr, downloadCSV } from "src/utils/utils";
import { errorNotification } from "src/utils/alerts";
import { MESSAGES, MigrationModalStyle } from "src/utils/constants";
import { useParams } from "react-router-dom";
import { migrateErrors } from "./migrateMessage";
import { closeAllModals, openModal } from "@mantine/modals";
import RelationMapping, { IDereferenceField } from "./RelationMapping";

type IClientImports = {
  locId: string;
};

function ClientImports({ locId }: IClientImports) {
  const [getSampleCsv, { loading: isCsvDownloading }] =
    useClientSampleCsvLazyQuery();

  const [migrateClients, { loading: uploadloading }] =
    useMigrateClientsMutation();

  const onUpload = async (jsonArr: IJsonArr) => {
    const clientJsonArrInput: ClientsJsonArrInput = {
      data: jsonArr as InternalClientsInput[],
    };

    const onSubmit = async () => {
      try {
        closeAllModals();
        const { data } = await migrateClients({
          variables: { data: clientJsonArrInput, locationId: locId },
        });
        data && migrateErrors(data.migrateClients.errors);
      } catch (err) {
        errorNotification({ message: MESSAGES.INVALID_CSV });
      }
    };

    const openModalSelect = () => {
      const fields: IDereferenceField[] = [
        {
          csvColumnHeader: "Gender",
          fieldName: "Gender",
          required: true,
          options:
            Object.values(Gender)?.map((val) => ({
              value: val,
              label: val,
            })) || [],
        },
      ];

      openModal({
        ...MigrationModalStyle,
        closeOnClickOutside: false,
        title: "Client Mapping",
        children: (
          <RelationMapping
            csvData={jsonArr}
            onSubmit={onSubmit}
            fields={fields}
          />
        ),
      });
    };

    const hasGender = clientJsonArrInput.data.find((c) => c.Gender);
    hasGender ? openModalSelect() : onSubmit();
  };

  const onDownload = async () => {
    const { data } = await getSampleCsv();
    downloadCSV(data?.clientSampleCSV, "Client_Sample.csv");
  };
  return (
    <>
      <ImportComponent
        title="Step 1 - Client Import"
        onDownload={onDownload}
        onUpload={onUpload}
        loading={isCsvDownloading}
        uploadloading={uploadloading}
      />
    </>
  );
}

export default memo(ClientImports);
